import { GridCellParams } from '@mui/x-data-grid-pro'
import Box from '@mui/material/Box'
import { Text } from '@mxenabled/mxui'

const getColors = (priority: any) => {
  const colors = {
    text: '#121417',
    background: '#FFB252',
  }

  if (priority === '!') {
    colors.text = '#FFFFFF'
    colors.background = '#DF320C'
  }

  if (priority === '✓') {
    colors.text = '#FFFFFF'
    colors.background = '#09A57F'
  }

  return colors
}

export const PriorityCell = (params: GridCellParams) => {
  const priority = String(params.formattedValue)
  const colors = getColors(priority)

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 20, // Adjust the size as needed
        height: 20,
        borderRadius: '50%',
        backgroundColor: colors.background,
        marginLeft: '10px',
      }}
    >
      <Text color={colors.text} fontWeight={700} variant="body2">
        {priority}
      </Text>
    </Box>
  )
}
